import {
  BooleanType,
  type FormkitBoolean,
  type UnaryBoolean,
  type FunctionBoolean,
  type BinaryBoolean,
  UnaryBooleanOperator,
} from "../api";

export type UnknownBoolean =
  | Omit<UnaryBoolean, "type">
  | Omit<BinaryBoolean, "type">
  | Omit<FunctionBoolean, "type">;

// biome-ignore lint/suspicious/noShadowRestrictedNames: TODO: refactor to different name
export function Boolean(props: UnknownBoolean): FormkitBoolean {
  // Function
  if ("function" in props) {
    return {
      type: BooleanType.Function,
      ...props,
    };
  }
  // Unary
  else if ("operand" in props) {
    return {
      type: BooleanType.Unary,
      ...props,
    };
  }
  // Binary
  else {
    return {
      type: BooleanType.Binary,
      ...props,
    };
  }
}

export const isUnaryBoolean = (o: unknown): o is UnaryBoolean => {
  return typeof o === "object" && o != null && o["type"] === BooleanType.Unary;
};

// This is not wise and will fail for anything that does not resolve to a raw `boolean`
// It should be deprecated and removed as soon as possible
export const getUnaryBooleanValue = (
  unaryBoolean: boolean | UnaryBoolean,
): boolean => {
  let val: boolean;
  if (isUnaryBoolean(unaryBoolean)) {
    val = !!unaryBoolean.operand;
    if (unaryBoolean.operator === UnaryBooleanOperator.Not) {
      val = !val;
    }
  } else {
    val = !!unaryBoolean;
  }
  return val;
};
